import { c as _c } from "react/compiler-runtime";
import { PaginationSkeleton } from '@morpho-org/ui-v6/client';
import { Skeleton } from '@morpho-org/ui-v6/server';
import MarketTransactionsLayout from '../MarketTransactionsLayout';
const MarketTransactionsLoading = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-[28px] w-[127px] rounded-[20px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MarketTransactionsLayout tableSettingsSlot={t0}><div className="gap-xs flex flex-col"><Skeleton className="h-[479px] w-[100%] rounded-[20px]" /><PaginationSkeleton /></div></MarketTransactionsLayout>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MarketTransactionsLoading;